// Helper per scaricare file protetti da autenticazione JWT.
//
// I pulsanti di download non possono usare window.open(): una normale
// navigazione del browser non invia l'header Authorization, quindi le rotte
// protette rispondono 401. Qui scarichiamo il file via fetch (con il Bearer
// token), poi forziamo il salvataggio tramite un anchor su un blob URL.
//
// `url` deve essere relativo (es. `/api/pratica/1/documenti/2/download`) così
// passa dal reverse proxy nginx verso il backend Node sulla stessa origin.
export async function downloadAutenticato(url, filenameFallback = 'documento') {
  const token = localStorage.getItem('token');

  const response = await fetch(url, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    let message = `Errore ${response.status} nel download del file`;
    try {
      const data = await response.json();
      if (data && data.error) message = data.error;
    } catch (_) {
      // risposta non JSON (es. binario o HTML): manteniamo il messaggio generico
    }
    throw new Error(message);
  }

  // Preferisci il nome file dichiarato dal server (Content-Disposition)
  let filename = filenameFallback;
  const disposition = response.headers.get('content-disposition');
  if (disposition) {
    const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(disposition);
    if (match && match[1]) {
      try {
        filename = decodeURIComponent(match[1]);
      } catch (_) {
        filename = match[1];
      }
    }
  }

  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
}

// Scarica un file protetto da JWT e restituisce un blob URL locale + il MIME
// type, da usare per mostrarlo in anteprima dentro l'app (es. in una modale con
// <iframe> per i PDF o <img> per le immagini). Chi lo usa è responsabile di
// chiamare URL.revokeObjectURL(blobUrl) quando chiude l'anteprima.
export async function fetchAnteprima(url) {
  const token = localStorage.getItem('token');
  const response = await fetch(url, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    let message = `Errore ${response.status} nell'anteprima del file`;
    try {
      const data = await response.json();
      if (data && data.error) message = data.error;
    } catch (_) {
      // risposta non JSON: messaggio generico
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  return { blobUrl: window.URL.createObjectURL(blob), type: blob.type };
}

// Apre un file protetto da JWT in anteprima (inline) in una nuova scheda.
// La scheda viene aperta SUBITO (in modo sincrono dentro l'onClick) per non
// finire bloccata dai popup blocker, poi reindirizzata al blob una volta scaricato.
export async function anteprimaAutenticata(url) {
  const tab = window.open('', '_blank');
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(url, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) {
      let message = `Errore ${response.status} nell'anteprima del file`;
      try {
        const data = await response.json();
        if (data && data.error) message = data.error;
      } catch (_) { /* risposta non JSON */ }
      throw new Error(message);
    }
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    if (tab) {
      tab.location.href = blobUrl;
    } else {
      window.open(blobUrl, '_blank');
    }
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
}

export default downloadAutenticato;
